import AdminApp from "./admin/AdminApp";
import LegalPage from "./components/LegalPage";
import DeleteAccountPage from "./components/DeleteAccountPage";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import HowItWorks from "./components/HowItWorks";
import WhyParkora from "./components/WhyParkora";
import TrustSection from "./components/TrustSection";
import OwnerSection from "./components/OwnerSection";
import CoimbatoreLaunch from "./components/CoimbatoreLaunch";
import Waitlist from "./components/Waitlist";
import OwnerRegistration from "./components/OwnerRegistration";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

export default function App() {
  if (window.location.pathname.startsWith("/admin")) {
    return <AdminApp />;
  }

  if (window.location.pathname.startsWith("/privacy-policy")) {
    return <LegalPage slug="privacy-policy" />;
  }

  if (window.location.pathname.startsWith("/terms-and-conditions")) {
    return <LegalPage slug="terms-and-conditions" />;
  }

  if (window.location.pathname.startsWith("/delete-account")) {
    return <DeleteAccountPage />;
  }

  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <SolutionSection />
        <HowItWorks />
        {/* ProductPreview (components/ProductPreview.jsx) is intentionally not
            rendered: its prototype pricing/promo contradicts the published
            Terms. Kept in source for a future, corrected release. */}
        <WhyParkora />
        <TrustSection />
        <OwnerSection />
        <CoimbatoreLaunch />
        <Waitlist />
        <OwnerRegistration />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
